<template>
  <div class="base-progress-liner slim">
    <div class="base-progress-liner__bg slim">
      <BaseProgressLinerBar
        v-for="(item, i) in barItems"
        :key="i"
        value=""
        :width="item.width"
        :color="item.color"
      />
    </div>
  </div>
</template>

<script>
import BaseProgressLinerBar from '@/components/BaseProgressLinerBar';
import cssVars from '@/assets/css/exports.scss';

const calcRatio = (numerator, denominator) =>
  Math.floor((100 * numerator) / denominator);

export default {
  name: 'BaseProgressLiner',
  components: {
    BaseProgressLinerBar,
  },
  props: {
    currentValue: {
      type: Number,
      required: true,
    },
    goal: {
      type: Number,
      required: true,
    },
    extraGoal1: {
      type: Number,
      required: false,
      default: 0,
    },
    extraGoal2: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    currentProgressRate() {
      return calcRatio(this.currentValue, this.goal);
    },
    barItems() {
      if (this.extraGoal1 && this.extraGoal2) {
        return [
          {
            value: `${this.currentProgressRate}%`,
            width: calcRatio(this.currentValue, this.extraGoal2),
            color: cssVars.cProgressbar3,
          },
          {
            value: `${calcRatio(this.extraGoal1, this.goal)}%`,
            width: calcRatio(this.extraGoal1, this.extraGoal2),
            color: cssVars.cProgressbar2,
          },
          {
            value: '100%',
            width: calcRatio(this.goal, this.extraGoal2),
            color: cssVars.cGreenBase,
          },
        ];
      }
      if (this.extraGoal1) {
        return [
          {
            value: `${this.currentProgressRate}%`,
            width: calcRatio(this.currentValue, this.extraGoal1),
            color: cssVars.cProgressbar2,
          },
          {
            value: '100%',
            width: calcRatio(this.goal, this.extraGoal1),
            color: cssVars.cGreenBase,
          },
        ];
      }
      return [
        {
          value: `${this.currentProgressRate}%`,
          width: calcRatio(this.currentValue, this.goal),
          color: cssVars.cGreenBase,
        },
      ];
    },
  },
};
</script>

<style lang="scss" scoped>
.base-progress-liner {
  background: transparent;
  width: 100%;
  height: $progressbar_h-bubble-area + $progressbar_h-bar;
  position: relative;

  &.slim {
    height: $progressbar_h-bar;
  }

  &__bg {
    position: absolute;
    top: $progressbar_h-bubble-area;
    left: 0;
    bottom: 0;
    transition: 0.3s ease-in;
    height: $progressbar_h-bar;
    opacity: 1;
    width: 100%;
    border-radius: 6px;
    background-color: map-get($c-black, 20);
    border-color: map-get($c-black, 20);

    &.slim {
      top: 0;
    }
  }
}
</style>
